module.exports = __webpack_public_path__ + "static/img/dowellsoft.d5181e2d.png";